import { ArchiveBoxIcon, CalendarIcon, CheckIcon, dayjs, RecurringIcon, ThemeIcon, UserIcon } from '@umanforge/common';
import { FmEventSearch } from 'interfaces/api_deep_search.interfaces';
import React from 'react';
import { BaseCardComponent } from '../baseCard.component';

interface FmEventCardProps {
  event: FmEventSearch;
}

const FmEventCardComponent: React.FC<FmEventCardProps> = ( { event } ) => {
  return (
    <BaseCardComponent
      id={ String( event.index ) }
      title={ event.eventTitle }
      breadcrumb={ `${ event.clientName } / ${ event.siteName } / ${ event.sectorName } / ${ event.eventManagerName }` }
      application={ event.application }
      firstChildren={
        <div className='flex h-full gap-2 event-searched-info p-1 pt-3'>
          <div className='flex gap-1 items-center'>
            <div className='relative flex h-fit w-fit p-1 gap-1.5 items-center rounded-md text-xs bg-gray-100 shadow-sm shadow-gray-400 border-none'>
              <div
                className="rounded-full group-hover:scale-[50] absolute trans-lessfast w-2.5 h-2.5 mr-2 -top-0.5 left-0 shadow-md"
                style={{ backgroundColor: event.themeColor }}
              />
              <ThemeIcon className='h-4 w-4'/>
              <span className='truncate pr-0.5'>{ event.themeName }</span>
            </div>
            {
              event.archived && (
                <div className='h-fit w-fit badge-purple'>
                  <ArchiveBoxIcon className='h-4 w-4'/>
                </div>
              )
            }
            {
              event.completed && (
                <div className='h-fit w-fit badge-green'>
                  <CheckIcon className='h-4 w-4'/>
                </div>
              )
            }
            {
              event.recurring && (
                <div className='h-fit w-fit badge-orange'>
                  <RecurringIcon className='h-4 w-4 p-[1.4px]'/>
                </div>
              )
            }
          </div>
          <div className='flex gap-4 w-fit items-center text-xs text-gray-700'>
            <div className='flex gap-1 items-center'>
              <UserIcon className='w-3.5 h-3.5'/>
              <span> { event.participantsFullname } </span>
            </div>
            <div className='flex gap-1 items-center'>
              <CalendarIcon className='w-3.5 h-3.5'/>
              <span> { dayjs( event.deliveryDate ).format( 'L' )} </span>
            </div>
          </div>
        </div>
      }
    />
  );
};

export { FmEventCardComponent };